import React from 'react';
import { FaFileContract } from 'react-icons/fa';
import './SoWHeroSection.css';

const SoWHeroSection = () => {
    return (
        <section className="_sHSec_j1A_">
            <div className="_sHCont_k2B_">
                <div className="_hIWrap_l3C_">
                    <FaFileContract className="_hIcon_m4D_" />
                </div>

                <h1 className="_hTitle_n5D_">
                    Vanidya Statements of Work:<br className="_bMobile_p7D_" />
                    Clear Commitments, Better Partnerships
                </h1>

                <p className="_hSubtitle_o6D_">
                    Every Vanidya engagement is guided by a transparent Statement of Work (SoW).
                    These documents outline expectations, responsibilities, service levels and deliverables—ensuring clarity and accountability for sellers, community partners and operational teams.
                </p>
            </div>
        </section>
    );
};

export default SoWHeroSection;